var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{staticClass:"back",attrs:{"size":"small","round":"","icon":"arrow-up"},on:{"click":_vm.goTop}},[_vm._v("顶部")])}
var staticRenderFns = []

export { render, staticRenderFns }